import { useRef, useState } from "react";
import { Download, Play, Loader2, BookmarkPlus } from "lucide-react";
import { fileUrl } from "@/constants/roles";

export const fmtTime = (s) => {
  if (s == null || Number.isNaN(s)) return "0:00";
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60);
  return `${m}:${String(sec).padStart(2, "0")}`;
};

export const VideoPlayer = ({ path, filename, testid, videoRef, onCapture }) => {
  const [ready, setReady] = useState(false);
  const [time, setTime] = useState(0);
  const internalRef = useRef(null);
  const ref = videoRef || internalRef;

  return (
    <div
      data-testid={testid}
      className="overflow-hidden rounded-2xl border border-[var(--pv-border)] bg-black"
      style={{ touchAction: "manipulation" }}
      onWheel={(e) => e.stopPropagation()}
    >
      <div className="relative">
        {!ready && (
          <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-2 bg-[var(--pv-bg)]">
            <Loader2 className="h-6 w-6 animate-spin text-cyan-400" />
            <p className="flex items-center gap-1.5 text-xs font-medium text-[var(--pv-text-4)]">
              <Play className="h-3 w-3" /> Loading preview...
            </p>
          </div>
        )}
        <video
          data-testid={`${testid}-video`}
          ref={ref}
          controls
          playsInline
          preload="metadata"
          src={fileUrl(path)}
          onLoadedMetadata={() => setReady(true)}
          onTimeUpdate={(e) => setTime(e.currentTarget.currentTime)}
          className="max-h-[65vh] w-full"
        />
      </div>
      <div className="flex items-center justify-between gap-3 border-t border-[var(--pv-border)] bg-[var(--pv-card)] px-4 py-2.5">
        <span className="truncate text-xs font-medium text-[var(--pv-text-3)]">{filename}</span>
        <div className="flex shrink-0 items-center gap-2">
          {onCapture && (
            <button
              type="button"
              data-testid={`${testid}-add-note`}
              onClick={() => onCapture(ref.current?.currentTime || 0)}
              className="flex items-center gap-1.5 rounded-full bg-cyan-500/15 border border-cyan-500/30 px-3 py-1.5 text-[11px] font-bold text-cyan-300 transition-colors hover:bg-cyan-500/25"
            >
              <BookmarkPlus className="h-3 w-3" /> Note at {fmtTime(time)}
            </button>
          )}
          <a
            data-testid={`${testid}-download`}
            href={fileUrl(path)}
            download={filename}
            className="flex items-center gap-1.5 rounded-full bg-[var(--pv-raised)] px-3 py-1.5 text-[11px] font-bold text-[var(--pv-text)] transition-colors hover:bg-[var(--pv-raised)]"
          >
            <Download className="h-3 w-3" /> Download
          </a>
        </div>
      </div>
    </div>
  );
};
